import './NextStepCardStyle.less';

import { NumberedIcon } from '@opendoor/bricks';
import React from 'react';

import SectionCard from '../common/SectionCard/SectionCard';
import SectionCardContent from '../common/SectionCard/SectionCardContent';

export interface INextStepCardProps {
  actionComponent?: JSX.Element;
  instructions?: JSX.Element[];
  title: string;
}

export default class NextStepCard extends React.PureComponent<INextStepCardProps> {
  public render(): JSX.Element {
    const { actionComponent, instructions, title } = this.props;

    return (
      <SectionCard className="resale-closing-dashboard-next-step-section" headerText="Next Step">
        <SectionCardContent>
          <div className="next-step-title">{title}</div>
          {instructions && this.renderInstructions()}
          {actionComponent}
        </SectionCardContent>
      </SectionCard>
    );
  }

  private renderInstructions = () => {
    return (
      <div className="instructions-container">
        {this.props.instructions.map((item, idx) => {
          return (
            <div className="instruction" key={idx}>
              <NumberedIcon num={idx + 1} className="instruction-icon" />
              {item}
            </div>
          );
        })}
      </div>
    );
  };
}
